// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"5ca7374a","285":"c8d1ae8b","458":"4add0676","774":"e2120590","858":"f70afb59","910":"839bc3cd","968":"0cec8a6e"}[chunkId] + ".chunk.js";
};